function ErrorPage() {
    return (
        <div>
            <h2>ERROR! PAGE NOT FOUND.</h2>
        </div>
    );
}

export default ErrorPage;